import { render, staticRenderFns } from "./MedicalInsuranceTab.vue?vue&type=template&id=25cd2bd0&scoped=true"
import script from "./MedicalInsuranceTab.vue?vue&type=script&lang=js"
export * from "./MedicalInsuranceTab.vue?vue&type=script&lang=js"
import style0 from "./MedicalInsuranceTab.vue?vue&type=style&index=0&id=25cd2bd0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cd2bd0",
  null
  
)

export default component.exports